class GalleryOption extends BaseOption {
    constructor(container) {
        super(container);
        
        if (!container.length) return;
        
        this.initGallery();
        this.initSubvalueSelect();
        this.initActiveSubvalues();
    }

    initGallery() {
        this.container.each((i, container) => {
            const $container = $(container);
            const galleries = $container.find('.swiper');
            
            this.initSliders(galleries);
        });

        this.values = this.container.find('.pc-option-gallery-section__value');
        this.bindEvents();
    }

    parseSubvalues(subvalues) {
        // Проверяем, что subvalues не пустые и являются строкой
        if (typeof subvalues === 'string' && subvalues.trim() !== '') {
            try {
                return JSON.parse(subvalues);
            } catch (e) {
                console.error('Error parsing subvalues:', e);
                return [];
            }
        } else if (!Array.isArray(subvalues)) {
            // Если это не массив и не строка JSON, возвращаем пустой массив
            return [];
        }
        return subvalues;
    }

    handleValueClick() {
        super.handleValueClick();
        
        this.values.on('click', (e) => {
            const $value = $(e.currentTarget);
            const $container = $value.closest('.pc-option-gallery');
            const index = $value.data('index');
            const section = $value.data('section');
            const optionId = $container.data('option-id');
            const activeSubvalue = $value.data('active-subvalue');
            
            let subvalues = this.parseSubvalues($value.data('subvalues'));

            this.removeSubvaluesRow($container);

            if (subvalues && subvalues.length) {
                this.createSubvaluesRow($value, $container, subvalues, optionId, section, index);
            }

            this.updateGallery($container, index, section, optionId);
        });
    }

    createSubvaluesRow($value, $container, subvalues, optionId, section, parentIndex, activeSubvalue = '') {
        const $valuesContainer = $value.closest('.pc-option-gallery-section__values');
        const $subvaluesRow = $('<div>', {
            class: 'pc-option-gallery-section__subvalues-row'
        });

        subvalues.forEach((subvalue, index) => {

            let active = '';

            if(activeSubvalue !== '' && activeSubvalue !== null && activeSubvalue !== undefined){
                active = (activeSubvalue == optionId + '_' + section + '_' + parentIndex + '_' + index) ? 'active' : '';

                if(active != '' && active === 'active'){
                    this.updateDescription($container, subvalue.subvalue_description);
                }
            }else{
                if(index === 0){
                    active = 'active';
                    this.updateDescription($container, subvalue.subvalue_description);
                }
            }

            const $subvalueElement = $('<div>', {
                class: 'pc-option-value pc-subvalue ' + active,
                'data-section': section,
                'data-index': parentIndex,
                'data-subvalue-index': index,
                'data-value': subvalue.subvalue_value,
                'data-description': subvalue.subvalue_description
            });


            if (subvalue.subvalue_preview && subvalue.subvalue_preview_icon) {
                $subvalueElement.append($('<span>', {

                    class: 'preview',
                    css: {
                        'background-image': `url(${subvalue.subvalue_preview_icon})`
                    }
                }));
            } else if (subvalue.subvalue_preview_color) {
                $subvalueElement.append($('<span>', {
                    class: 'preview',
                    css: {
                        'background-color': subvalue.subvalue_preview_color
                    }
                }));
            }

            $subvalueElement.append($('<span>', {
                class: 'value-label',
                text: subvalue.subvalue_label || 'No label'
            }));

            $subvalueElement.on('click', (e) => {
                e.stopPropagation();
                $('.pc-subvalue').removeClass('active');
                $(e.currentTarget).addClass('active');
                this.onSubvalueSelect($(e.currentTarget));
            });

            $subvaluesRow.append($subvalueElement);
        });

        $valuesContainer.after($subvaluesRow);
    }

    removeSubvaluesRow($container) {
        $container.find('.pc-option-gallery-section__subvalues-row').remove();
    }

    updateDescription($option, description) {
        if (!description) return;

        const $gallery = $option.find('.pc-option-gallery-galleries');
        const $description = $gallery.find('.pc-option-value-description');
        
        if ($description.length) {
            $description.html(description);
        } else {
            $gallery.append($('<div>', {
                class: 'pc-option-value-description',
                html: description
            }));
        }
    }

    onSubvalueSelect($subvalue) {
        const value = $subvalue.data('value');
        const description = $subvalue.data('description');
        const $optionValue = this.container.find('.pc-option-gallery-section__value.active');
        const $option = $optionValue.closest('.pc-option');
        
        $optionValue.attr('data-value', value);
        this.updateDescription($option, description);
        
        const changeData = {
            element: $option,
            optionSlug: $option.data('option-slug'),
            value: value
        };
        
        $(document).trigger('option-changed', [changeData]);
    }

    onValueSelect($value) {
        super.onValueSelect($value);
        const value = $value.data('value');
        const $option = $value.closest('.pc-option');
        
        const changeData = {
            element: $option,
            optionSlug: $option.data('option-slug'),
            value: value
        };
        
        $(document).trigger('option-changed', [changeData]);
    }

    updateGallery($container, index, section, optionId) {
        const $galleries = $container.find('.pc-option-gallery-galleries');
        
        if ($galleries.hasClass('loading')) {
            return;
        }

        $.ajax({
            url: pc_ajax_object.ajax_url,
            type: 'POST',
            data: {
                action: 'update_gallery',
                index: index,
                section: section,
                option_id: optionId,
                _ajax_nonce: pc_ajax_object.nonce
            },
            beforeSend: () => {
                $galleries.addClass('loading');
            },
            success: (response) => {
                if (response.success) {
                    $galleries.html(response.data.html);
                    
                    const newGallery = $galleries.find('.swiper');
                    if (newGallery.length) {
                        this.initSliders(newGallery);
                    }
                }
            },
            complete: () => {
                $galleries.removeClass('loading');
            }
        });
    }

    initSliders(galleries) {
        galleries.each((index, element) => { 
            if (element) {
                // Создаем SVG для стрелок
                const arrowSvg = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15 19L8 12L15 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>`;

                const swiper = new Swiper(element, {
                    slidesPerView: 1,
                    effect: 'fade',
                    fadeEffect: {
                        crossFade: true
                    },
                    speed: 800,
                    navigation: {
                        nextEl: element.querySelector('.swiper-button-next'),
                        prevEl: element.querySelector('.swiper-button-prev'),
                    },
                    pagination: false,
                });

                const prevButton = element.querySelector('.swiper-button-prev');
                const nextButton = element.querySelector('.swiper-button-next');
                if (prevButton) prevButton.innerHTML = arrowSvg;
                if (nextButton) nextButton.innerHTML = arrowSvg;
            }
        });
    }

    initSubvalueSelect() {
        this.container.on('click', '.subvalue-item', (e) => {
            const $subvalueItem = $(e.currentTarget);
            const $optionValue = $subvalueItem.closest('.pc-option-value');
            const $option = $subvalueItem.closest('.pc-option');
            const $subvalueLabel = $optionValue.find('.subvalue-label span:first-child');
            
            $subvalueLabel.text($subvalueItem.text());
            $optionValue.attr('data-value', $subvalueItem.data('value'));
            
            const changeData = {
                element: $option,
                optionSlug: $option.data('option-slug'),
                value: $subvalueItem.data('value')
            };
            
            $(document).trigger('option-changed', [changeData]);
        });
    }

    initActiveSubvalues() {
        this.container.each((i, container) => {
            const $container = $(container);
            const $activeValue = $container.find('.pc-option-gallery-section__value.active:not(.pc-subvalue)');
            
            if ($activeValue.length) {
                let subvalues = this.parseSubvalues($activeValue.data('subvalues'));

                if (subvalues && subvalues.length) {
                    const optionId = $container.data('option-id');
                    const section = $activeValue.data('section');
                    const index = $activeValue.data('index');
                    const activeSubvalue = $activeValue.data('active-subvalue');
                    
                    this.createSubvaluesRow($activeValue, $container, subvalues, optionId, section, index, activeSubvalue);
                }
            }
        });
    }
}
